module.exports = __webpack_public_path__ + "img/fontumi-congrats-animation.16f2d0f9.gif";